/* PA Card — mobile swipe + desktop gallery, (+) sizes overlay */
(function () {
  const MODEL_VIEW_STORAGE_KEY = 'onedilemma:model-image-view';

  function getStoredModelView() {
    try {
      return window.localStorage.getItem(MODEL_VIEW_STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function storeModelView(enabled) {
    try {
      window.localStorage.setItem(MODEL_VIEW_STORAGE_KEY, enabled ? 'true' : 'false');
    } catch (e) {}
  }

  function applyModelView(enabled) {
    document.documentElement.toggleAttribute('data-collection-model-view', enabled);
    document.querySelectorAll('[data-model-image-toggle]').forEach((toggle) => {
      toggle.checked = enabled;
    });
  }

  function setupModelToggle(root) {
    const toggles = Array.from((root || document).querySelectorAll('[data-model-image-toggle]'));
    if (!toggles.length) return;

    const stored = getStoredModelView();
    applyModelView(stored);

    toggles.forEach((toggle) => {
      if (toggle.__modelToggleInit) return;
      toggle.__modelToggleInit = true;
      toggle.addEventListener('change', () => {
        const enabled = toggle.checked;
        storeModelView(enabled);
        applyModelView(enabled);
      });
    });
  }

  window.checkboxClick = function () {
    const toggle = document.querySelector('[data-model-image-toggle]');
    if (!toggle) return;
    storeModelView(toggle.checked);
    applyModelView(toggle.checked);
  };

  function setupCard(card) {
    if (card.__paCardInit) return;
    card.__paCardInit = true;

    const slider = card.querySelector('[data-card-slider]');
    const track = card.querySelector('[data-card-track]');
    const counterCurrent = card.querySelector('[data-card-current]');
    const plus = card.querySelector('[data-card-plus]');
    const overlay = card.querySelector('[data-card-sizes-overlay]');
    const link = card.querySelector('[data-card-link]');
    const picker = card.querySelector('[data-card-variant-picker]');
    const priceWrap = card.querySelector('.pa-card__price');
    const initialPriceHtml = priceWrap ? priceWrap.innerHTML : '';
    let selectedVariant = null;
    let sizeOpener = null;

    const pickerVariants = picker ? Array.from(picker.querySelectorAll('[data-card-variant]')).map((node) => {
      try {
        return {
          id: node.dataset.id,
          options: JSON.parse(node.dataset.options),
          available: node.dataset.available === 'true',
          price: node.dataset.price,
          compare: node.dataset.compare,
        };
      } catch (e) { return null; }
    }).filter(Boolean) : [];
    let optionNames = [];
    if (picker) {
      try { optionNames = JSON.parse(picker.dataset.optionNames); } catch (e) {}
    }
    const sizeIndex = picker ? Number(picker.dataset.sizeIndex) : -1;
    const extraIndexes = optionNames.map((_, index) => index).filter((index) => index !== sizeIndex);

    function showVariantPrice(variant) {
      if (!priceWrap || !variant) return;
      priceWrap.replaceChildren();
      const price = document.createElement('span');
      price.className = variant.compare ? 'pa-card__price-sale' : 'pa-card__price-regular';
      price.textContent = variant.price;
      priceWrap.append(price);
      if (variant.compare) {
        const compare = document.createElement('span');
        compare.className = 'pa-card__price-compare';
        compare.textContent = variant.compare;
        priceWrap.append(compare);
      }
    }

    function closeVariantPicker(restoreFocus) {
      if (!picker) return;
      card.removeAttribute('data-variant-picker-open');
      picker.setAttribute('aria-hidden', 'true');
      selectedVariant = null;
      if (priceWrap) priceWrap.innerHTML = initialPriceHtml;
      const error = picker.querySelector('[data-card-picker-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
      if (restoreFocus && sizeOpener) sizeOpener.focus();
    }

    function openVariantPicker(size, opener) {
      if (!picker || !pickerVariants.length) return;
      const choices = picker.querySelector('[data-card-picker-choices]');
      const addButton = picker.querySelector('[data-card-picker-add]');
      const sizeText = picker.querySelector('[data-card-picker-size]');
      const optionText = picker.querySelector('[data-card-picker-option-label]');
      const error = picker.querySelector('[data-card-picker-error]');
      sizeOpener = opener;
      selectedVariant = null;
      if (priceWrap) priceWrap.innerHTML = initialPriceHtml;
      if (error) { error.hidden = true; error.textContent = ''; }
      sizeText.textContent = `${optionNames[sizeIndex] || 'Talla'} ${size}`;
      optionText.textContent = extraIndexes.map((index) => optionNames[index]).join(' · ');
      addButton.disabled = true;
      addButton.textContent = picker.dataset.addLabel;
      choices.replaceChildren();
      pickerVariants.filter((variant) => variant.options[sizeIndex] === size).forEach((variant) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pa-card__variant-choice';
        const label = extraIndexes.map((index) => extraIndexes.length === 1
          ? variant.options[index]
          : `${optionNames[index]}: ${variant.options[index]}`).join(' · ');
        button.textContent = `${label} · ${variant.available ? variant.price : picker.dataset.soldOutLabel}`;
        button.disabled = !variant.available;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          selectedVariant = variant;
          choices.querySelectorAll('button').forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
          showVariantPrice(variant);
          addButton.disabled = false;
          addButton.textContent = `${picker.dataset.addLabel} · ${variant.price}`;
        });
        choices.append(button);
      });
      card.setAttribute('data-variant-picker-open', '');
      picker.setAttribute('aria-hidden', 'false');
      (choices.querySelector('button:not(:disabled)') || picker.querySelector('[data-card-variant-close]')).focus();
    }

    if (picker) {
      picker.querySelector('[data-card-variant-close]').addEventListener('click', () => closeVariantPicker(true));
      picker.querySelector('[data-card-picker-add]').addEventListener('click', (event) => {
        event.preventDefault();
        if (selectedVariant) addVariant(selectedVariant.id, event.currentTarget);
      });
      picker.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); closeVariantPicker(true); }
      });
    }

    /* Keep the image count in sync with swipes and arrow navigation. */
    if (track && counterCurrent) {
      let raf;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          const total = track.querySelectorAll('.pa-card__slide').length;
          const idx = Math.max(0, Math.min(total - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
          counterCurrent.textContent = String(idx + 1);
          raf = null;
        });
      }, { passive: true });
    }

    /* Prev/Next arrows */
    const prevBtn = card.querySelector('[data-card-prev]');
    const nextBtn = card.querySelector('[data-card-next]');
    if (track && (prevBtn || nextBtn)) {
      const total = track.querySelectorAll('.pa-card__slide').length;
      const goTo = (idx) => {
        const clamped = Math.max(0, Math.min(total - 1, idx));
        track.scrollTo({ left: track.clientWidth * clamped, behavior: 'smooth' });
      };
      const current = () => Math.round(track.scrollLeft / track.clientWidth);
      if (prevBtn) prevBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        card.setAttribute('data-interacted', '');
        goTo(current() - 1);
      });
      if (nextBtn) nextBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        card.setAttribute('data-interacted', '');
        goTo(current() + 1);
      });
    }

    /* Plus button toggles sizes overlay (mobile). Prevent navigating the link. */
    if (plus && overlay) {
      plus.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const open = card.hasAttribute('data-sizes-open');
        if (open) {
          card.removeAttribute('data-sizes-open');
          plus.setAttribute('aria-expanded', 'false');
          overlay.setAttribute('aria-hidden', 'true');
        } else {
          card.setAttribute('data-sizes-open', '');
          plus.setAttribute('aria-expanded', 'true');
          overlay.setAttribute('aria-hidden', 'false');
        }
      });
      /* Tap outside overlay (still inside the card) closes it */
      card.addEventListener('click', (e) => {
        if (!card.hasAttribute('data-sizes-open')) return;
        if (e.target.closest('[data-card-plus]')) return;
        if (e.target.closest('.pa-card__size')) return;
        if (e.target.closest('[data-card-sizes-overlay]') && !e.target.closest('.pa-card__sizes-grid')) {
          e.preventDefault();
          e.stopPropagation();
          card.removeAttribute('data-sizes-open');
          plus.setAttribute('aria-expanded', 'false');
          overlay.setAttribute('aria-hidden', 'true');
        }
      });
    }

    /* Block link navigation when overlay is open OR when user just swiped */
    let touchStartX = 0, touchStartY = 0, touchMoved = false;
    if (slider) {
      slider.addEventListener('touchstart', (e) => {
        const t = e.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
        touchMoved = false;
      }, { passive: true });
      slider.addEventListener('touchmove', (e) => {
        const t = e.touches[0];
        if (Math.abs(t.clientX - touchStartX) > 8 || Math.abs(t.clientY - touchStartY) > 8) {
          touchMoved = true;
          card.setAttribute('data-interacted', '');
        }
      }, { passive: true });
    }

    /* Desktop drag-to-swipe (mouse) */
    if (track) {
      let isDown = false, startX = 0, startScroll = 0, dragged = false;
      const total = track.querySelectorAll('.pa-card__slide').length;

      track.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        isDown = true;
        dragged = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
      });
      window.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 4) {
          dragged = true;
          touchMoved = true;
          card.setAttribute('data-interacted', '');
          e.preventDefault();
        }
        track.scrollLeft = startScroll - dx;
      });
      window.addEventListener('mouseup', (e) => {
        if (!isDown) return;
        isDown = false;
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = '';
        if (dragged) {
          /* Snap to nearest slide */
          const idx = Math.round(track.scrollLeft / track.clientWidth);
          const clamped = Math.max(0, Math.min(total - 1, idx));
          track.scrollTo({ left: track.clientWidth * clamped, behavior: 'smooth' });
          /* Suppress the click that follows mouseup */
          const suppress = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
          window.addEventListener('click', suppress, { capture: true, once: true });
          setTimeout(() => {
            try { window.removeEventListener('click', suppress, { capture: true }); } catch (e) {}
            touchMoved = false;
          }, 50);
        }
      });
    }

    if (link) {
      link.addEventListener('click', (e) => {
        if (card.hasAttribute('data-sizes-open') || touchMoved) {
          e.preventDefault();
          e.stopPropagation();
          touchMoved = false;
        }
      });
    }

    /* Check every variant of a size; multi-option products need an explicit choice. */
    async function addVariant(id, btn) {
        if (!id || btn.disabled) return;
        btn.disabled = true;
        const original = btn.textContent;
        btn.textContent = '...';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
          });
          if (!res.ok) {
            const response = await res.json().catch(() => ({}));
            throw new Error(response.description || 'No se pudo añadir a la cesta.');
          }
          closeVariantPicker(false);
          /* Close overlay */
          if (plus && overlay) {
            card.removeAttribute('data-sizes-open');
            plus.setAttribute('aria-expanded', 'false');
            overlay.setAttribute('aria-hidden', 'true');
          }
          /* Refresh + open cart drawer */
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            if (typeof drawer.refresh === 'function') await drawer.refresh();
            /* refresh() can replace the <cart-drawer> node, so re-query and open the live one */
            const liveDrawer = document.querySelector('cart-drawer');
            if (liveDrawer && typeof liveDrawer.open === 'function') liveDrawer.open();
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          console.error('Quick-buy failed', err);
          const error = picker && picker.querySelector('[data-card-picker-error]');
          if (error && card.hasAttribute('data-variant-picker-open')) {
            error.textContent = err.message;
            error.hidden = false;
          }
        } finally {
          btn.disabled = false;
          btn.textContent = original;
        }
    }

    card.querySelectorAll('[data-quick-buy]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        if (picker) {
          openVariantPicker(btn.dataset.cardSize, btn);
        } else {
          addVariant(btn.dataset.variantId, btn);
        }
      });
    });
  }

  function init(root) {
    setupModelToggle(root);
    (root || document).querySelectorAll('[data-card]').forEach(setupCard);
  }

  window.shopifyReinitCards = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  /* Re-init on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
